<template>
  <q-card bordered v-if="filteredArray.length" class="q-pa-xs q-mt-xs">
    <q-list bordered separator class="text-bold q-pa-none q-ma-none">
      <q-item class="row" v-for="item in filteredArray" :key="item">
        <q-item-section> {{ item.name }}</q-item-section>

        <q-separator vertical></q-separator>

        <q-item-section class="text-right q-ml-lg">
          <span>
            <q-chip
              class="text-bold"
              size="sm"
              :color="item.value == 'Y' ? 'teal' : 'red '"
              text-color="white"
              >{{ item.value }}</q-chip
            >
          </span>
        </q-item-section>
      </q-item>
    </q-list>
    <!-- <span class="row" v-for="item in filteredArray" :key="item">
      <span>{{ item.name }}</span>
      <q-space />

      <q-chip
        class="text-bold"
        size="sm"
        :color="item.value == 'Y' ? 'teal' : 'red '"
        text-color="white"
        >{{ item.value }}</q-chip
      >
    </span>
    <q-separator /> -->
  </q-card>
</template>
<script>
import { ref, onMounted, watch } from "vue";
import { LocalStorage, useQuasar } from "quasar";

import { useStore } from "vuex";
import useData from "src/use/data";

export default {
  name: "StockwiseKeyValueComponents",
  props: {
    symbol: {
      type: String,
      default: "NEPSE",
    },
  },
  setup(props) {
    const store = useStore();
    const {
      priceActionFilterHourly,
      priceActionFilterDaily,
      priceActionFilterWeekly,
    } = useData();
    const $q = useQuasar();
    const selectedDate = ref("");
    const priceActionDataDaily = ref([]);
    const listData = ref([]);
    const resultData = ref([]);
    const signalItems = ref([]);
    const filteredArray = ref([]);

    function loadData(date, symbol) {
      priceActionFilterDaily(date?.replaceAll("/", "-"))
        .then((res) => {
          priceActionDataDaily.value = res.data;
          getData(priceActionDataDaily.value);
          $q.loading.hide();
        })
        .catch((err) => {
          $q.loading.hide();
        });

      function getData(data) {
        listData.value = data;

        function getSignal(symbol) {
          signalItems.value = listData.value.filter((item) => {
            return item.symbol === symbol;
          })[0];
          resultData.value = [];
          filteredArray.value = [];

          if (signalItems.value) {
            resultData.value = [
              {
                name: "Simple Moving Average (20)",
                value: signalItems.value?.sma20_yn,
              },
              {
                name: "Simple Moving Average (50)",
                value: signalItems.value?.sma50_yn,
              },
              {
                name: "Simple Moving Average (200)",
                value: signalItems.value?.sma200_yn,
              },
              { name: "Pivot Level", value: signalItems.value?.pivot_yn },
              {
                name: "Pivot Level Support (S1)",
                value: signalItems.value?.pivot_s1_yn,
              },
              {
                name: "Pivot Level Support (S2)",
                value: signalItems.value?.pivot_s2_yn,
              },
              {
                name: "Pivot Level Support (S3)",
                value: signalItems.value?.pivot_s3_yn,
              },
              {
                name: "Pivot Level Resistance (R1)",
                value: signalItems.value?.pivot_r1_yn,
              },
              {
                name: "Pivot Level Resistance (R2)",
                value: signalItems.value?.pivot_r2_yn,
              },
              {
                name: "Pivot Level Resistance (R3)",
                value: signalItems.value?.pivot_r3_yn,
              },
              {
                name: "Swing Level Support (S)",
                value: signalItems.value?.swing_s_yn,
              },
              {
                name: "Swing Level Support (S1)",
                value: signalItems.value?.swing_s1_yn,
              },
              {
                name: "Swing Level Support (S2)",
                value: signalItems.value?.swing_s2_yn,
              },
              {
                name: "Swing Level Resistance (R)",
                value: signalItems.value?.swing_r_yn,
              },
              {
                name: "Swing Level Resistance (R1)",
                value: signalItems.value?.swing_r1_yn,
              },
              {
                name: "Swing Level Resistance (R2)",
                value: signalItems.value?.swing_r2_yn,
              },
              {
                name: "Lower Bollinger Band",
                value: signalItems.value?.low_bb_yn,
              },
              {
                name: "Middle Bollinger Band",
                value: signalItems.value?.middle_bb_yn,
              },
              { name: "Average Volume", value: signalItems.value?.avg_vol_yn },
            ];

            filteredArray.value = resultData.value.filter(
              (item) => item.value === "Y"
            );
          }
        }
        getSignal(symbol);
      }
    }

    onMounted(() => {
      selectedDate.value = store.state.market.asOf;

      if (selectedDate.value !== "") {
        loadData(selectedDate.value, props.symbol);
      }
    });
    watch(props, (newProps, oldProps) => {
      loadData(selectedDate.value, newProps.symbol);
    });

    return {
      resultData,
      signalItems,
      listData,
      filteredArray,
    };
  },
};
</script>
